import { useContext } from 'react'
import { LoginScreenContext } from '../contexts/LoginScreenContext'

const useLoginState = () => {
  const value = useContext(LoginScreenContext)
  return value
}

export default useLoginState
